import { z } from 'zod';
export const tasksNotificationsCapability = 'tasks.notifications.v1';
function isIanaTimeZone(value) {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value }).format(new Date(0));
        return true;
    }
    catch {
        return false;
    }
}
export const tasksReminderFrequencySchema = z.enum(['off', 'daily', 'weekdays', 'hourly']);
export const tasksNotificationPreferencesSchema = z.strictObject({
    membershipId: z.string().uuid(),
    configured: z.boolean(),
    assignmentEmailEnabled: z.boolean(),
    reminderEmailEnabled: z.boolean(),
    reminderFrequency: tasksReminderFrequencySchema,
    reminderTimeLocal: z.string().regex(/^(?:[01][0-9]|2[0-3]):[0-5][0-9]$/),
    timeZone: z.string().trim().min(1).max(100)
        .refine(isIanaTimeZone, 'Expected an IANA time zone.'),
    updatedAt: z.string().datetime({ offset: true }).nullable(),
});
export const tasksUpdateNotificationPreferencesSchema = z.strictObject({
    assignmentEmailEnabled: z.boolean().optional(),
    reminderEmailEnabled: z.boolean().optional(),
    reminderFrequency: tasksReminderFrequencySchema.optional(),
    reminderTimeLocal: z.string().regex(/^(?:[01][0-9]|2[0-3]):[0-5][0-9]$/).optional(),
    timeZone: z.string().trim().min(1).max(100)
        .refine(isIanaTimeZone, 'Expected an IANA time zone.').optional(),
}).refine((value) => Object.keys(value).length > 0, {
    message: 'At least one notification preference must be provided.',
});
export const tasksNotificationPreferencesResponseSchema = z.strictObject({
    data: tasksNotificationPreferencesSchema,
});
export const tasksNotificationKindSchema = z.enum(['assignment', 'due_soon', 'open_digest']);
export const tasksNotificationTaskSnapshotSchema = z.strictObject({
    taskId: z.string().uuid(),
    title: z.string().trim().min(1).max(240),
    priority: z.enum(['low', 'normal', 'high', 'urgent']),
    dueAt: z.string().datetime({ offset: true }).nullable(),
    projectLabel: z.string().trim().min(1).max(320).nullable(),
});
export const tasksNotificationIntentSchema = z.strictObject({
    id: z.string().uuid(),
    tenantId: z.string().uuid(),
    intentKey: z.string().min(1).max(500),
    notificationKind: tasksNotificationKindSchema,
    channel: z.literal('email'),
    recipientMembershipId: z.string().uuid(),
    taskSnapshots: z.array(tasksNotificationTaskSnapshotSchema).min(1).max(100),
    scheduledFor: z.string().datetime({ offset: true }),
    configurationReleaseId: z.string().uuid().nullable(),
    requestedAt: z.string().datetime({ offset: true }),
});
export const tasksPrepareNotificationIntentsSchema = z.strictObject({
    asOf: z.string().datetime({ offset: true }),
    recipientLimit: z.number().int().min(1).max(500).default(100),
});
export const tasksNotificationIntentBatchSchema = z.strictObject({
    data: z.array(tasksNotificationIntentSchema).max(1_000),
    counts: z.strictObject({
        assignment: z.number().int().nonnegative(),
        dueSoon: z.number().int().nonnegative(),
        openDigest: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=tasks-notification.contract.js.map